var URL = "/";
var URL_MOCK = "/mock";
export var PATH_GET_FAQS = URL_MOCK + "/faqs";